export default __webpack_public_path__ + "static/media/bg-top-m2.af457a75.png";